// extracted by mini-css-extract-plugin
export default {"root":"ApiError-root","icon":"ApiError-icon","content":"ApiError-content"};